module.exports = __webpack_public_path__ + "static/media/Berth Monitoring.62cf5296.png";